<template>
  <div v-if="isLoggedIn" class="profile-page d-flex flex-md-row flex-column px-4 py-4 mb-4">
    <ProfileSidebar />
    <main class="content ps-md-4">
      <AmetistPromotion />
      <a
        v-if="isAdmin"
        class="portal-statistics-link"
        href="/admin/accounts/portalvisit/"
        target="_blank"
        rel="noopener"
      >
        Статистика портала и рекламы
      </a>
      <router-view />
    </main>
    <MobileBar />
  </div>
</template>

<script>
  import { defineComponent, computed, onMounted } from 'vue';
  import ProfileSidebar from '@/components/Profile/Sidebar.vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import MobileBar from '@/components/Profile/MobileBar.vue';
  import AmetistPromotion from '@/components/Profile/AmetistPromotion.vue';

  export default defineComponent({
    name: 'Profile',
    components: { ProfileSidebar, MobileBar, AmetistPromotion },
    setup() {
      const store = useStore();
      const isLoggedIn = computed(() => store.state.auth.status.loggedIn);
      const isAdmin = computed(() => store.state.user.user?.is_staff || store.state.user.user?.is_superuser);
      const router = useRouter();

      onMounted(() => {
        if (!isLoggedIn.value) {
          router.push('/');
        } else {
          store.dispatch('user/getCartItems');
        }
      });

      return {
        isLoggedIn,
        isAdmin,
      };
    },
  });
</script>

<style lang="scss">
  @import '../assets/styles/Profile';
  .profile-page .content {
    min-width: 0;
  }
  .portal-statistics-link {
    display: inline-block;
    margin-bottom: 20px;
    color: #0066ce;
    font-size: 15px;
  }
</style>
